'use strict';
/**
 * This stores the checkboxes as an integer. Each bit will represent one of the checkboxes - a 1 means it was checked, a 0 means unchecked
 */

angular.module('msUtility').directive('msCheckboxGroup', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    scope: {},
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      scope.$watch('$last', function () {
        var boxes = ele.find('input:checkbox');
        boxes.change(function () {
          var i = 0;
          boxes.each(function () {
            var split = this.getAttribute('id').split('-');
            // the checkbox didn't have an appropriately named id
            if (split.length !== 2) {
              return;
            }
            var pos = parseInt(split[1]);
            // flip a bit in the "pos" position of i
            /*jslint bitwise: true */
            i = i | +this.checked << pos;
          });
          ngModel.$setViewValue(i);
        });
      });
      ngModel.$render = function () {
        $timeout(function () {
          var boxes = ele.find('input:checkbox');
          boxes.each(function () {
            this.checked = true;
            var pos = parseInt(this.getAttribute('id').split('-')[1]);
            // find the bit in the "pos" position
            /*jslint bitwise: true */
            this.checked = !!(parseInt(ngModel.$viewValue) >> pos & 0x1);
          });
        });
      };
    }
  };
}]);